// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

import i18n from "./lang/i18n";

import store from "./store/index.js";

// router setup
import router from "./router";

//import helper
import "./helpers/validation-config";
import * as filters from "./helpers/filters";
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// plugin setup
Vue.use(DashboardPlugin);

// global library setup
Vue.prototype.$Chartist = Chartist;

// import GoogleAuth from "@/helpers/google_oAuth.js";
// const gAuthOption = {
//   clientId: process.env.VUE_APP_GOOGLE_ID,
//   scope: "profile email",
//   prompt: "select_account"
// };
// Vue.use(GoogleAuth, gAuthOption);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n
});
